import { ClientService_GetClient, ClientService_ListClients } from '@src/gen/ai/h2o/cloud/discovery/v1/client_api_pb';
import { EnvironmentService_GetEnvironment } from '@src/gen/ai/h2o/cloud/discovery/v1/environment_api_pb';
import {
  ServiceService_GetService,
  ServiceService_ListServices,
} from '@src/gen/ai/h2o/cloud/discovery/v1/service_api_pb';
import { RequestConfig } from '@src/gen/runtime';
import { fetchWrapRPC } from '@shared/services/appstore/api';

const requestConfig: RequestConfig = {
  basePath: `${import.meta.env.VITE_API_PATH || window.origin}/.ai.h2o.cloud.discovery`,
  bearerToken: undefined, // the discovery service does not need auth, the `Authorization` header can cause CORS issues
};

export const getEnvironment = fetchWrapRPC(EnvironmentService_GetEnvironment, requestConfig);

export const getClient = fetchWrapRPC(ClientService_GetClient, requestConfig);

export const listClients = fetchWrapRPC(ClientService_ListClients, requestConfig);

export const getService = fetchWrapRPC(ServiceService_GetService, requestConfig);

export const listServices = fetchWrapRPC(ServiceService_ListServices, requestConfig);
